module.exports = __webpack_public_path__ + "img/calendar-11.287ad12d.svg";